module.exports = __webpack_public_path__ + "img/personal_info.6f3ef9c5.jpg";